import React from 'react';
import PropTypes from 'prop-types';
const isObject = require('lodash/isObject');
const _ = {
    find: require('lodash/find'),
    assign: require('lodash/assign'),
};

import { Button } from 'react-bootstrap';
const uuid = require('uuid');
import { withRouter, Prompt } from 'react-router-dom';
import ProgressButton from '@muzzylane/react-progress-button';

const verUtil = require('../util/version.js');
const PermissionsUtil = require('../../../app/shared/PermissionsUtil');
const SignInStore = require('../stores/SignInStore');
const ActivityStore = require('../stores/activity_store_reflux');
const ActivityActions = require('../actions/ActivityActions');
const WebSocketStore = require('../stores/WebSocketStore');
const WebSocketActions = require('../actions/WebSocketActions');
import TopNav from './DashboardNew/Menu/TopNav';
import LoadingMainContent from './loading/LoadingMainContent';
import SingleInputModal from './modal/SingleInputModal2';
import WarningBox from './common/WarningBox';
import HelpDropdown from './nav/HelpDropdown';
import IFrame from './IFrame';
import WithActivityData from './DataHOCs/WithActivityData';
import WithTemplateData from './DataHOCs/WithTemplateData';
import WithChannelData from './DataHOCs/WithChannelData';
import WithProjectData from './DataHOCs/WithProjectData';
import WithDocumentVisible from './DataHOCs/WithDocumentVisible';
import WithActivityEditAccessData from './DataHOCs/WithActivityEditAccessData';
import WithSiteMaintenanceMode from './DataHOCs/WithSiteMaintenanceMode';
import Tooltip from './common/Tooltip';
import ThreeModal from './modal/ThreeModal';
import ValidationReport from './validation/ValidationReport';
import AccessibleIcon from './common/AccessibleIcon';
import ForceCloseEditModal from './modal/ForceCloseEditModal';
import { PreviewView } from './PreviewActivityEditorReviewView';
const RSDActions = require('../actions/RSDActions');
const RSDStore = require('../stores/RSDStore');
const VoiceStore = require('../stores/VoiceStore');
const ChatbotSystem = require('../util/ChatbotSystem');

const propTypes = {
    history: PropTypes.object.isRequired,
    activityId: PropTypes.string.isRequired,
    projectId: PropTypes.string.isRequired,
    channelId: PropTypes.string.isRequired,
    activityVersion: PropTypes.string,
    activityStoreState: PropTypes.shape({ activity: PropTypes.object }).isRequired,
    projectStoreState: PropTypes.shape({ project: PropTypes.shape({ user_permissions: PropTypes.object.isRequired}).isRequired }).isRequired,
    channelStoreState: PropTypes.shape({ channel: PropTypes.shape({ user_permissions: PropTypes.object.isRequired}).isRequired }).isRequired,
    templateStoreState: PropTypes.shape({
        template: PropTypes.shape({
            template_url: PropTypes.string.isRequired,
            editor_url: PropTypes.string.isRequired,
        }).isRequired
    }).isRequired,
    activityEditAccessInfo: PropTypes.shape({ id: PropTypes.string.isRequired, access_key: PropTypes.string.isRequired, permissions: PropTypes.object.isRequired }).isRequired,
};

const defaultProps = {
    activityVersion: '',
};

class EditActivityView extends React.Component {
    constructor(props) {
        super(props);

        let signInStoreState = SignInStore.getState();
        let unsavedChanges = false;
        let autoSaveInfo = null;
        let autosavePrefix = null;
        let autosaveModal = 0;
        let editingVersion = null;
        let launchedOldVersion = false;
        this.versionIsOld = this.versionIsOld.bind(this);
        if (props.activityVersion) {
            editingVersion = props.activityVersion; // Redmine #5902
            // if we loaded an autosave, it starts out 'unsaved'.
            // Also, set autoSaveInfo version for the preview button
            if (verUtil.parseVersion(props.activityVersion).isAutosave()) {
                unsavedChanges = true;
                /*
                autoSaveInfo = {
                    version: props.activityVersion
                };
                */
            }
            else if (this.versionIsOld(editingVersion)) {
                launchedOldVersion = true;
            }
        }
        else {
            if (props.activityStoreState && props.activityStoreState.activityAutoSaveInfo) {
                let autoSaveInfo = props.activityStoreState.activityAutoSaveInfo;
                let savedBySameUser = false;
                if (autoSaveInfo && autoSaveInfo.moreRecent) {
                    if (autoSaveInfo.saveById == signInStoreState.userInfo.id) {
                        savedBySameUser = true;
                    }
                    let save_d = new Date(autoSaveInfo.saveDate);
                    const by_text = autoSaveInfo.userName ? (" by " + autoSaveInfo.userName) : "";
                    const day_text = save_d.toLocaleDateString();
                    const time_text = save_d.toLocaleTimeString();

                    if (savedBySameUser) {
                        editingVersion = autoSaveInfo.version;
                        unsavedChanges = true;
                        console.log(`automatically loading autosave created for ${autoSaveInfo.userName} on ${day_text} at ${time_text}`);
                    }
                    else {
                        autosavePrefix = `Autosave created${by_text} on ${day_text} at ${time_text} found.`;
                        autosaveModal = 1;
                    }
                }
            }
        }

        this.state = {
            mode: 'EDIT',
            signInStoreState,
            webSocketStoreState: WebSocketStore.getState(),
            lockProcessBegun: false,
            unsavedChanges: unsavedChanges,
            // autoSaveInfo: autoSaveInfo,
            clientFeatures: {
                autosave: false,
                validate: false,
                user_data: false,
                goto_comment: false,
            },
            modalState: {
                save: false,
                closeUnsaved: false
            },
            presave: false, // true of we're waiting for validation data before showing the save prompt
            pendingSave: false,
            pendingAutosave: false,
            previewAfterAutosave: false, // true if we're autosaving then previewing the autosave
            autosavePrefix,autosaveModal,
            closeAfterAutosave: false,
            closeAfterSave: false,
            hadLockOnce: false,
            currentlyHaveLock: false,
            previewFrom: '',
            previewVersion: null,
            editingVersion,
            launchedOldVersion,
            releaseLockActionId: null,
            closeAfterRelease: false,
            saveButtonState: '',
        };

        this.iframe = React.createRef();
        this.getAutosaveButtonData = this.getAutosaveButtonData.bind(this); 
        this.allowLeave = this.allowLeave.bind(this);
        this._handleEditorMessages = this._handleEditorMessages.bind(this);
        this.setupWs = this.setupWs.bind(this);
        this.ensureLockReleased = this.ensureLockReleased.bind(this);
        this.releaseLockAndClose = this.releaseLockAndClose.bind(this);
        this.onClose = this.onClose.bind(this);
        this.gotoPreview = this.gotoPreview.bind(this);
        this.gotoPreviewCurrent = this.gotoPreviewCurrent.bind(this);
        this.gotoPreviewVersion = this.gotoPreviewVersion.bind(this);
        this.gotoEdit = this.gotoEdit.bind(this);
        this.goBack = this.goBack.bind(this);
        this.getEditingVersion = this.getEditingVersion.bind(this);
        this.checkToClearForceUnlockState = this.checkToClearForceUnlockState.bind(this);
        this.onSave = this.onSave.bind(this);
        this.save = this.save.bind(this);
        this.autosave = this.autosave.bind(this);
        this.tickForceClosedCountdown = this.tickForceClosedCountdown.bind(this);
        this.onClientFeatures = this.onClientFeatures.bind(this);
        this.editingVersionIsOld = this.editingVersionIsOld.bind(this);
        this.setSaveModalState = this.setSaveModalState.bind(this);
        this.setCloseUnsavedModalState = this.setCloseUnsavedModalState.bind(this);
        this.deleteAutoSaveAndClose = this.deleteAutoSaveAndClose.bind(this);
        this.saveAndClose = this.saveAndClose.bind(this);
        this.sendUserData = this.sendUserData.bind(this);

        this.unsubscribes = [
            SignInStore.listen(this.onSignInStoreChange.bind(this)),
            WebSocketStore.listen(this.onWebsocketStoreChange.bind(this)),
            RSDStore.listen(this.onRSDStoreChange),
        ];

        const userData = {...props.activityEditAccessInfo, 
            activityId: props.activityId ? Number(props.activityId) : null,
            channelId: props.channelId ? Number(props.channelId) : null,
        }
        this.voiceSystem = VoiceStore.getVoiceSystem(VoiceStore.SYSTEM_USAGE.ACTIVITY_EDIT,{userData});
        this.chatbotSystem = new ChatbotSystem({userData, usage: ChatbotSystem.SYSTEM_USAGE.ACTIVITY_EDIT});
    }

    UNSAFE_componentWillMount() {
        if (this.props.activityStoreState.initialized && !this.props.activityStoreState.activity) {
            this.props.history.push(`/project/${this.props.channelId}/${this.props.projectId}`);
            return;
        }

        this.setupWs();
    }

    componentDidMount() {
        $(window).off('message', this._handleEditorMessages).on('message', this._handleEditorMessages);
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.activityStoreState.action.id === this.state.deleteAutosaveActionId) {
            this.setState({ deleteAutosaveActionId: null }, () => {
                if (nextProps.activityStoreState.action.error) {
                    console.warn('Error deleting autosave:', JSON.stringify(nextProps.activityStoreState.action.error));
                }

                if (this.state.closePendingAutoSaveDeletion) { // will transition back regardless of error
                    this.setState({ unsavedChanges: false }, this.releaseLockAndClose);
                }
            });
        }

        if (
            this.state.closeAfterSave
            && !this.state.unsavedChanges
            && !nextProps.activityStoreState.activityAutoSaveInfo.available
        ) {
            this.releaseLockAndClose();
        }

    }

    componentDidUpdate(prevProps) {
        if (prevProps.activityEditAccessInfo.access_key !== this.props.activityEditAccessInfo.access_key) {
            this.sendUserData();
        }
    }

    componentWillUnmount() {
        if (this.autosaveInterval) {
            window.clearInterval(this.autosaveInterval);
        }

        if (this.forceClosedTimer) {
            window.clearTimeout(this.forceClosedTimer);
        }

        if (this.getActLockTimer) {
            window.clearInterval(this.getActLockTimer);
        }

        $(window).off('message', this._handleEditorMessages);
        $(window).off('beforeunload');
        this.checkToClearForceUnlockState();
        this.ensureLockReleased(); // ensure lock is released in case non-close button navigation away
        this.unsubscribes.forEach(u => u());
        if (this.voiceSystem) {
            this.voiceSystem.shutDown();
        }
        if (this.chatbotSystem) {
            this.chatbotSystem.shutDown();
        }
    }

    getAutosaveButtonData(confirmingDeleteAutosave) {
        const autoSaveInfo = this.props.activityStoreState.activityAutoSaveInfo;
        const buttonData = [
            {
                text: "Load Autosave",
                handler: () => {
                    this.setState({
                        autosavePrefix: null,
                        autosaveModal: 0,
                        editingVersion: autoSaveInfo.version,
                        unsavedChanges: true,
                    });
                },
                disabled: confirmingDeleteAutosave,
                variant: confirmingDeleteAutosave ? 'secondary' : undefined,
            },
            {
                text: confirmingDeleteAutosave ? "Confirm Discard" : "Discard Autosave",
                variant: confirmingDeleteAutosave ? 'danger' : undefined,
                handler: () => {
                    if (confirmingDeleteAutosave) {
                        ActivityActions.deleteAutosave(uuid.v4(), {
                            projectId: this.props.projectId,
                            activityId: this.props.activityId,
                            version: autoSaveInfo.version
                        });
                        this.setState({
                            autosavePrefix: null,
                            autosaveModal: 0,
                        });
                    }
                    else {
                        this.setState({autosaveModal: 2});
                        // this.goBack();
                    }
                },
            },
            {
                text: "Cancel",
                handler: () => { 
                    if (confirmingDeleteAutosave) {
                        this.setState({autosaveModal: 1});
                    }
                    else {
                        this.goBack();
                    }
                },
            }
        ];
        return buttonData;
    }

    allowLeave(location, action) {
        if (this.state.previewAfterAutosave || this.state.closeAfterAutosave) {
            if (!this.state.pendingAutosave) {
                return true; // ok to leave without saving because the autosave finished ok
            }

        }

        if (this.state.unsavedChanges && !this.editingVersionIsOld()) { // do not prompt for unsaved changes when editing older version
            return 'You have unsaved changes. Are you sure you wish to leave this page?';
        }

        return true;
    }

    _handleEditorMessages(e) {
        const self = this;
        const msg = e.originalEvent.data;
        const origin = e.originalEvent.origin;
        //console.debug('EDITOR _handleEditorMessages', origin, msg);

        if (!GlobalConfig.DevMode && origin.indexOf('muzzylane.com') === -1) {
            return;
        }
        

        if (isObject(msg)) {
            const targetWindow = this.iframe && this.iframe.current && this.iframe.current.contentWindow;
            if (this.chatbotSystem) {
                let handled = this.chatbotSystem.handleMessage(msg,targetWindow);
                if (handled) {
                    return;
                }
            }
            if (this.voiceSystem) {
                let handled = this.voiceSystem.handleMessage(msg,targetWindow);
                if (handled) {
                    return;
                }
            }
            switch (msg.type) {
                case "saved": {
                    console.log("saved ", msg.version);
                    ActivityActions.updateActivityVersion(uuid.v4(), {
                        projectId: this.props.projectId,
                        activityId: this.props.activityId,
                        version: msg.version
                    });
                    ActivityActions.updateActivityAutoSaveInfo(uuid.v4(), {
                        projectId: this.props.projectId,
                        activityId: this.props.activityId,
                        autoSaveInfo: {
                            available: false,
                            moreRecent: false
                        }
                    });
                    if (!this.state.closeAfterSave) {
                        ActivityActions.getActivity(uuid.v4(), { // TODO: do we really need to refetch all activity data?
                            activityId: this.props.activityId,
                            projectId: this.props.projectId,
                            channelId: this.props.channelId
                        });
                    }

                    this.setState({
                        unsavedChanges: false,
                        pendingSave: false,
                        saveButtonState: 'success'
                    }, () => {
                        // note this will not cause a close if autoSaveInfo.available is just being set to false.
                        // props.activityStore.state.autoSaveInfo.available = false  will not be propagated until after this statement is complete
                        // ... in this case, UNSAFE_componentWillReceiveProps will take care of back navigation
                        if (self.state.closeAfterSave) {
                            self.onClose();
                        }
                        else {
                            // Redmine #5902. Prevent issue when loading autosave in editor, saving, previewing, and then returning to editor loads _originally_ loaded autosave
                            if (self.props.activityVersion) {
                                // self.props.history.replace(`/project/${self.props.channelId}/${self.props.projectId}/activity/${self.props.activityId}/edit`);
                                // hack to avoid re-navigation. see caveats: https://stackoverflow.com/questions/57101831/react-router-how-do-i-update-the-url-without-causing-a-navigation-reload
                                window.history.replaceState(null, '', `/project/${self.props.channelId}/${self.props.projectId}/activity/${self.props.activityId}/edit`);
                            }
                        }
                    });
                    break;
                }
                case "changes": {
                    this.setState({ unsavedChanges: true });
                    break;
                }
                case "save-failed": {
                    this.setState({ saveButtonState: 'error' });
                    // TODO: use msg.error somehow
                    console.log("Error saving: ", msg.error);
                    break;
                }
                case 'features': {// client telling forge what it can do
                    this.onClientFeatures(msg.features);
                    break;
                }
                case 'validation': {
                    let presaveCurrent = this.state.presave;
                    this.setState({
                        presave: false,
                        save_validation: msg.validation,
                    }, 
                    () => {
                        if (presaveCurrent) {
                            self.setSaveModalState(true);
                        }                            
                    });

                    break;
                }
                case "autosaved": {
                    console.log('autosaved:', msg.autoSaveInfo);
                    ActivityActions.updateActivityAutoSaveInfo(uuid.v4(), {
                        projectId: this.props.projectId,
                        activityId: this.props.activityId,
                        autoSaveInfo: _.assign(msg.autoSaveInfo,{
                            available: true,
                            moreRecent: true,
                        })
                    });
                    this.setState(
                        {
                            pendingAutosave: false,
                            autoSaveInfo: msg.autoSaveInfo,
                        },
                        () => {
                        if (this.state.previewAfterAutosave) {
                            this.gotoPreviewVersion(msg.autoSaveInfo.version);
                        }
                        else if (this.state.closeAfterAutosave) {
                            this.onClose();
                        }
                    });
                    break;
                }
                case "autosave-unchanged": {
                    // console.log('autosave-unchanged', msg);
                    this.setState({pendingAutosave: false}, function() {
                        if (self.state.previewAfterAutosave && self.props.activityStoreState.activityAutoSaveInfo) {
                            self.gotoPreviewVersion(self.props.activityStoreState.activityAutoSaveInfo.version);
                        }
                        else if (self.state.previewAfterAutosave) {
                            console.warn('Possible editor bug: unsavedChanges is set, "autosave-unchanged" called, autoSaveInfo unavailable.');
                            // template has likely sent changes message, but has not yet set 'autosave dirty' flag
                            // TODO: indicate that autosave is still pending, so that user will be warned prior to preview transition
                            self.gotoPreviewCurrent()
                        }
                        else if (self.state.closeAfterAutosave) {
                            self.onClose();
                        }
                    });
                    break;
                }
                case "autosave-failed": {
                    // console.log('autosave-failed');
                    this.setState({
                        pendingAutosave: false,
                        previewAfterAutosave: false, // cancel this mode
                        closeAfterAutosave: false, // cancel this also
                    });
                    console.log("Error autosaving: ", msg.error);
                    break;
                }
                case "request-user-data": {
                    this.sendUserData();
                    break;
                }
                case "request-rsd-services": {
                    this.sendRSDServicesToIframe();
                    break;
                }
                case "request-rsds": {
                    this.sendRSDsToIframe(msg.rsd_service_id);
                    break;
                }
                case "request-rsd": {
                    this.sendRSDToIframe(msg.rsd_service_id, msg.rsd_id);
                    break;
                }
                case "preview-from": {
                    this.setState({ previewFrom: msg.location });
                    break;
                }
            }
        }
        else {
            // TEMPORARY until all templates use the new format
            let unknownMsg = false;
            switch (msg) {
                case "saved":
                    ActivityActions.getActivity(uuid.v4(), { activityId: this.props.activityId, projectId: this.props.projectId, channelId: this.props.channelId });
                    this.setState({unsavedChanges: false, pendingSave: false, saveButtonState: 'success' });
                    break;
                case "change":
                case "changes":
                    this.setState({unsavedChanges: true});
                    break;
                case "save-failed":
                    this.setState({ saveButtonState: 'error' });
                    break;
                default:
                    unknownMsg = true;
                    // console.warn("Received unknown msg:", msg);
                    break;
            }
            if (!unknownMsg) {
                console.warn("Received deprecated old-style save API");
            }
                
        }
    }

    setupWs() {
        const self = this;
        this.getActLockTimer = window.setInterval(() => {
            if (self.props.activityStoreState.initialized) {
                window.clearInterval(self.getActLockTimer);
                delete self.getActLockTimer;
                //console.log('EditActivityView WebSocketActions.getActivityLock...');
                self.setState({ lockProcessBegun: true }, () => {
                    WebSocketActions.getActivityLock(uuid.v4(), {
                        "product": self.props.activityStoreState.activity.product,
                        "moduleId": self.props.activityStoreState.activity.module_id,
                        "moduleVersion": self.props.activityStoreState.activity.module_version,
                        "activityId": self.props.activityStoreState.activity.activity_id,
                        "activityVersion": self.props.activityStoreState.activity.version,
                        "userId": self.state.signInStoreState.userInfo.id //todo: better scheme for this
                    });
                });
            }
        }, 2000);
    }

    ensureLockReleased() {
        WebSocketActions.ensureLockReleased(
            uuid.v4(),
            {
                actWebSocket: this.state.webSocketStoreState.actWebSocket,
                connectionLost: this.state.webSocketStoreState.connection_lost,
                lockProcessBegun: this.state.lockProcessBegun,
            }
        );
    }

    releaseLockAndClose() {
        console.debug('releaseLockAndClose');
        const releaseLockActionId = uuid.v4();
        this.setState({
            releaseLockActionId: releaseLockActionId,
            closeAfterRelease: true,
            lockProcessBegun: false,
        }, () => {
            WebSocketActions.ensureLockReleased(
                releaseLockActionId,
                {
                    actWebSocket: this.state.webSocketStoreState.actWebSocket,
                    connectionLost: this.state.webSocketStoreState.connection_lost,
                    lockProcessBegun: this.state.lockProcessBegun,
                }
            );
        })
    }

    onSignInStoreChange(state) {
        this.setState({ signInStoreState: state });
    }

    tickForceClosedCountdown(newSecondsLeft) {
        if (newSecondsLeft <= 0) {
            if (this.state.unsavedChanges) {
                if (this.state.clientFeatures.autosave) {
                    this.setState({
                        pendingAutosave: true,
                        closeAfterAutosave: true,
                    }, this.autosave);
                }
                else {
                    console.log("creating force unlock save (autosave not supported by template)");
                    this.setState({
                        closeAfterSave: true,
                    }, this.save.bind(this, 'force unlock'));
                }
            }
            else {
                this.onClose();
            }
        }
        else {
            this.setState({ forceClosedSeconds: newSecondsLeft });
            this.forceClosedTimer = window.setTimeout(this.tickForceClosedCountdown.bind(this, newSecondsLeft - 1), 1000);
        }
    }

    onWebsocketStoreChange(state) {
        if (
            state.action.id === this.state.releaseLockActionId
            && this.state.closeAfterRelease
        ) { // regardless of error
            console.debug('closing after lock released...');
            this.goBack();
            return;
        }

        const currentlyHaveLock = !!state.actWebSocket && !!state.actWebSocket._haveLock && !state.connection_lost;
        const lockId = currentlyHaveLock ? state.actWebSocket.lockId : -1;

        let forceClosedSeconds = this.state.forceClosedSeconds;
        if (currentlyHaveLock && state.force_unlock_data) {
            if (!this.state.webSocketStoreState.force_unlock_data) {
                // start our close countdown. This can't be cancelled.
                if (this.forceClosedTimer) {
                    console.log("keeping previous forceClosedTimer"); // let the existing timer run out
                }
                else {
                    const now = new Date();
                    const elapsed = now - state.force_unlock_data.start_time;
                    const remaining = state.force_unlock_data.timeout_ms - elapsed;
                    const seconds = Math.floor(remaining / 1000);
                    forceClosedSeconds = Math.max(2,seconds); // allow at least 2 seconds
                    this.forceClosedTimer = window.setTimeout(this.tickForceClosedCountdown.bind(this, forceClosedSeconds - 1), 1000);
                }
            }
        }

        this.setState({
            webSocketStoreState: state,
            hadLockOnce: this.state.hadLockOnce || currentlyHaveLock,
            currentlyHaveLock: currentlyHaveLock,
            lockId: lockId,
            forceClosedSeconds: forceClosedSeconds
        });
    }

    getRSDsIfStored=(rsd_service_id)=>{
        let rsds = RSDStore.getStateChannelRSDS(this.props.channelId, rsd_service_id);
        if (rsds) {
            return rsds.map((rsd)=>{
                let formatted_rsd = {
                    rsd_service_id: rsd_service_id,
                    rsd_id: rsd.rsd_id,
                    name: rsd.name,
                    description: rsd.description || '',
                };
                if (rsd.invalid) {
                    formatted_rsd.invalid = true;
                }
                return formatted_rsd;
            })
        }
    }

    getRSDIfStored=(rsd_service_id, rsd_id)=>{
        let channelState = RSDStore.getStateChannel(this.props.channelId);
        let rsd;
        if (channelState.external_rsds) {
            rsd = _.find(channelState.external_rsds, {rsd_service_id, rsd_id});
        }
        if (!rsd) {
            // see if it happens to be in the internal list
            let rsds = RSDStore.getStateChannelRSDS(this.props.channelId, rsd_service_id);
            if (rsds) {
                rsd = _.find(rsds, {rsd_id});
            }
        }
        if (rsd) {
            return {
                rsd_service_id,
                rsd_id,
                name: rsd.name,
                description: rsd.description || '',
            }
        }
    }
    
    getRSDServicesIfStored=()=>{
        if (this.state.rsd_services) {
            return this.state.rsd_services;
        }
        let channelState = RSDStore.getStateChannel(this.props.channelId);
        if (channelState && channelState.rsdServices && channelState.rsdServices.rsd_services) {
            let rsd_services = channelState.rsdServices.rsd_services;
            this.setState({rsd_services});
            return rsd_services;
        }
    }

    onRSDStoreChange=(storeState)=>{
        if (storeState.action && storeState.action.id) {
            if (this.state.get_rsd_services_actionId === storeState.action.id) {
                let rsd_services = this.getRSDServicesIfStored();
                if (!rsd_services) {
                    // we got an error trying to get rsd services. Give up and return an empty array.
                    console.log("failed to get rsd_services"); // FIXME: remove debug spam
                    rsd_services = [];
                }
                let unsolicited = this.state.unsolicited_rsd_services_request;
                this.setState({
                    get_rsd_services_actionId: null,
                    rsd_services,
                },()=>{
                    if (unsolicited) {
                        console.log("onRSDStoreChange got rsd_services but client hadn't requested them"); // FIXME: remove debug spam
                    }
                    this.sendRSDServicesToIframe(); // send the data anyway in case the timing was just off
                });
            }
            else if (this.state.get_rsds_actionId === storeState.action.id) {
                let rsd_service_id = this.state.get_rsds_service_id;
                this.setState({
                    get_rsds_actionId: null,
                    get_rsds_service_id: null
                },()=>{
                    this.sendRSDsToIframe(rsd_service_id, storeState.action.error);
                });
            }
            else if (this.state.get_name_and_description_actionId === storeState.action.id) {
                // these are always stored in the external_rsds
                let {rsd_service_id, rsd_id} = this.state.rsd_params;
                this.setState({
                    get_name_and_description_actionId: null,
                    rsd_params: null
                },()=>{
                    this.sendRSDToIframe(rsd_service_id, rsd_id, storeState.action);
                });
            }
        }
    }

    onClose() {
        if (
            !this.editingVersionIsOld()
            && (
                this.state.unsavedChanges
                || (
                    this.props.activityStoreState.activityAutoSaveInfo
                    && this.props.activityStoreState.activityAutoSaveInfo.available
                )
            )
        ) {
            this.setCloseUnsavedModalState(true);
        }
        else {
            this.releaseLockAndClose();
        }
    }

    deleteAutoSaveAndClose() {
        if (
            this.state.clientFeatures.autosave
            && this.props.activityStoreState.activityAutoSaveInfo
            && this.props.activityStoreState.activityAutoSaveInfo.available
        ) {
            const deleteAutosaveActionId = uuid.v4();
            this.setState({
                deleteAutosaveActionId: deleteAutosaveActionId,
                closePendingAutoSaveDeletion: true
            }, () => {
                ActivityActions.deleteAutosave(deleteAutosaveActionId, {
                    projectId: this.props.projectId,
                    activityId: this.props.activityId,
                    version: this.props.activityStoreState.activityAutoSaveInfo.version
                });
            });
        }
        else {
            this.setState({ unsavedChanges: false }, this.releaseLockAndClose);
        }
    }

    saveAndClose() {
        // TODO check
        this.setState({ closeAfterSave: true }, () => { this.setSaveModalState(true); });
    }

    gotoPreview() {
        //if (this.state.unsavedChanges && this.state.clientFeatures.autosave) {
        if (this.state.clientFeatures.autosave) { // always try an autosave. The client can return autosave-unchanged if needed. Fix for redmine # 2883
            this.setState({
                pendingAutosave: true,
                previewAfterAutosave: true,
            }, this.autosave);
        }
        else {
            const editingVersion = this.getEditingVersion();
            if (
                editingVersion
                && !verUtil.parseVersion(editingVersion).isAutosave()
                && !this.state.launchedOldVersion
            ) {
                this.gotoPreviewVersion(editingVersion);
            }
            else {
                this.gotoPreviewCurrent();
            }
        }
    }

    gotoPreviewCurrent() {
        console.debug('gotoPreviewCurrent');
        $(window).off('message', this._handleEditorMessages);
        if (this.autosaveInterval) {
            window.clearInterval(this.autosaveInterval);
			delete this.autosaveInterval;
        }

        // redmine #5923
        let additionalState = {};
        if (this.state.launchedOldVersion) {
            // user launched old version, did save, and is now previewing
            // clear flags related to originally launching old version as it is now current
            additionalState = {
                editingVersion: null,
                launchedOldVersion: false,
            };
        }

        this.setState({ mode: 'PREVIEW', previewVersion: null, previewAfterAutosave: false, ...additionalState });
    }

    gotoPreviewVersion(version) {
        console.debug('gotoPreviewVersion', version);
        $(window).off('message', this._handleEditorMessages);
        if (this.autosaveInterval) {
            window.clearInterval(this.autosaveInterval);
            delete this.autosaveInterval;
        }

        // redmine #5923
        let additionalState = {
            previewVersion: version,
        };
        if (this.state.launchedOldVersion) {
            // user launched old version, did save, and is now previewing
            // clear flags related to originally launching old version as it is now current
            additionalState = {
                ...additionalState,
                editingVersion: null,
                launchedOldVersion: false,
                previewVersion: null,
            };
        }

        this.setState({ mode: 'PREVIEW', previewVersion: version, previewAfterAutosave: false, ...additionalState });
    }

    gotoEdit() {
        $(window).off('message', this._handleEditorMessages).on('message', this._handleEditorMessages);
        if (!this.autosaveInterval) {
            this.autosaveInterval = window.setInterval(this.autosave, 1000*30);
        }

        this.setState({ mode: 'EDIT', previewVersion: null, editingVersion: this.state.previewVersion });
    }

    goBack() {
        console.debug('goBack');
        this.props.history.push(`/project/${this.props.channelId}/${this.props.projectId}/activity/${this.props.activityId}`);
    }

    getEditingVersion() {
        const editingVersion = this.state.editingVersion || null;
        return editingVersion;
    }
    
    checkToClearForceUnlockState() {
        // make sure we clear the unlock state if we're leaving the editor
        if (this.state.webSocketStoreState && this.state.webSocketStoreState.force_unlock_data) {
            WebSocketActions.clearForceUnlockState(uuid.v4(), this.state.webSocketStoreState.force_unlock_data);
        }
    }

    onSave() {
        // todo: uncomment this when all templates support the unsavedChanges api
        // if(!this.state.unsavedChanges) {
        //     return;
        // }

        const self = this;
        this.setState({ save_validation: null }, () => {
            if (self.state.clientFeatures.validate) {
                const iframe = this.iframe.current;
                iframe.contentWindow.postMessage({type: 'validate'},'*');
                self.setState({ presave:true });
            }
            else {
                self.setSaveModalState(true);
            }
        });

    }

    save(message) {
        const iframe = this.iframe.current;
        this.setState({
            pendingSave: true,
            modalState: { ...this.state.modalState, save: false },
            saveButtonState: 'loading',
        }, () => {
            if (!this.state.clientFeatures.autosave) {
                // TEMPORARY until all the templates support the new format
                iframe.contentWindow.postMessage('save', '*');
            }

            iframe.contentWindow.postMessage(
                {
                    type: 'save',
                    authorId: this.state.signInStoreState.userInfo.id,
                    message: message,
                    options: {
                        keepOldVersions: true
                    },
                },
                '*'
            );
        });
    }

    autosave() {
        if (this.state.autosaveModal) {
            return;
        }
        const editingVersion = this.getEditingVersion();
        if (editingVersion) {
            if (verUtil.parseVersion(editingVersion).isAutosave()) {
                // continue. allow additional autosaves
            }
            else if (this.editingVersionIsOld()) { // disallow autosaves when editing older versions
                console.log('editing old version: aborting autosave');
                if (this.state.previewAfterAutosave) {
                    this.gotoPreviewVersion(editingVersion);
                    return;
                }

                this.setState({ pendingAutosave: false });
                return;
            }
        }

        //console.log('autosave() call postMessage');
        const iframe = this.iframe.current;
        iframe.contentWindow.postMessage({
            type: 'autosave',
            authorId: this.state.signInStoreState.userInfo.id,
        }, '*');
    }

    onClientFeatures(features) {
        const self = this;
        this.setState({ clientFeatures: features }, () => {
            self.sendUserData();
        });

        if (!this.autosaveInterval) {
            this.autosaveInterval = window.setInterval(this.autosave, 1000*30);
        }
    }

    versionIsOld(version) {
        const parsedVersion = verUtil.parseVersion(version);
        const currentWorkingVersion = this.props.activityStoreState.activity.version;

        if (parsedVersion.compare(currentWorkingVersion) === -1) {
            return true;
        }

        return false
    }

    editingVersionIsOld() {
        // editing version is older than current working version
        const editingVersion = this.getEditingVersion();
        if (editingVersion) {
            return this.versionIsOld(editingVersion);
        }

        return false;
    }

    setSaveModalState(showBool, callback=null) {
        this.setState({ modalState: { ...this.state.modalState, save: showBool } }, () => {
            if (typeof callback === 'function') callback();
        });
    }

    setCloseUnsavedModalState(showBool) {
        this.setState({ modalState: { ...this.state.modalState, closeUnsaved: showBool } });
    }

    sendUserData() {
        if (this.state.clientFeatures.user_data) {
            const iframe = this.iframe.current;
            if (!!iframe) {
                iframe.contentWindow.postMessage({ type: 'user-data', user_data: this.props.activityEditAccessInfo }, '*');
            }
            
            const comment = ActivityStore.getAndClearEditGotoComment(this.props.activityId);
            if (comment && this.state.clientFeatures.goto_comment && !!iframe) {
                iframe.contentWindow.postMessage({ type: 'goto-comment', id: comment.id, location: comment.location }, '*');
            }
        }
    }
    
    sendRSDServicesToIframe=(unsolicited)=>{
        const iframe = this.iframe.current;
        if (!iframe) {
            console.log("sendRSDServicesToIframe does not know iframe"); // FIXME: remove debug spam
            return;
        }
        var rsd_services = this.getRSDServicesIfStored(); // see if it's already in the store or in our state
        if (!rsd_services) {
            if (this.state.get_rsd_services_actionId) {
                if (!unsolicited) { // iframe has requested this
                    if (this.state.unsolicited_rsd_services_request) {
                        // forge client anticipated the request before the iframe asked, but it is asking now
                        console.log('request-rsd-services anticipated'); // FIXME: remove debug spam
                        this.setState({unsolicited_rsd_services_request: false});
                    }
                    else {
                        console.log('request-rsd-services pending'); // FIXME: remove debug spam
                        iframe.contentWindow.postMessage({ type: 'rsd-services', pending: true}, '*');
                    }
                }
                return;
            }
            console.log("requesting rsd_services from server"); // FIXME: remove debug string
            let get_rsd_services_actionId = uuid.v4();
            this.setState({
                get_rsd_services_actionId,
                unsolicited_rsd_services_request: unsolicited
            },()=>{
                RSDActions.getChannelRSDServices(get_rsd_services_actionId,{channelId:this.props.channelId});
            });
            return;
        }
        let msg = {
            type: 'rsd-services',
            rsd_services: rsd_services.map((svc)=>({rsd_service_id: svc.id, name: svc.name}))
        };
        iframe.contentWindow.postMessage(msg, '*');
    }

    sendRSDsToIframe=(rsd_service_id,actionError)=>{
        const iframe = this.iframe.current;
        if (!iframe) {
            console.log("sendRSDsToIframe does not know iframe");
            return;
        }
        if (actionError) {
            console.log(`iframe requested rsds for rsd_service_id ${rsd_service_id} but we got an error`, actionError);
            iframe.contentWindow.postMessage({ type: 'rsds', rsd_service_id, rsds: [], invalid: true}, '*'); 
            return;
        }
        
        var rsd_services = this.getRSDServicesIfStored();
        if (!rsd_services) {
            if (this.state.get_rsd_services_actionId) {
                console.log(`cannot send rsds until we have rsd services`); // FIXME: remove debug spam
            }
            else {
                this.sendRSDServicesToIframe(true); // anticipate request-rsd-services (and we need the data to validate the rsds request
            }
            iframe.contentWindow.postMessage({ type: 'rsds', rsd_service_id, busy: true}, '*'); // tell client we're busy so it knows to request again
            return;
        }
        var serviceData = _.find(rsd_services,{id:rsd_service_id});
        if (!serviceData) {
            console.log(`iframe requested rsds for invalid rsd_service_id ${rsd_service_id}`);
            iframe.contentWindow.postMessage({ type: 'rsds', rsd_service_id, rsds: [], invalid: true}, '*'); 
            return;
        }
        
        
        var rsds = this.getRSDsIfStored(rsd_service_id);
        if (!rsds) {
            if (this.state.get_rsds_actionId) {
                if (rsd_service_id !== this.state.get_rsds_service_id) {
                    console.log(`too busy requesting rsds for ${this.state.get_rsds_service_id} to request for ${rsd_service_id}`); // FIXME: remove debug spam
                    iframe.contentWindow.postMessage({ type: 'rsds', rsd_service_id, busy: true}, '*');
                }
                else {
                    iframe.contentWindow.postMessage({ type: 'rsds', rsd_service_id, pending: true}, '*');
                }
                return;
            }
            console.log(`requesting rsds for ${rsd_service_id}`); // FIXME: remove debug spam
            let get_rsds_actionId = uuid.v4();
            this.setState({get_rsds_actionId, get_rsds_service_id: rsd_service_id},()=>{
                RSDActions.getChannelServiceRSDs(get_rsds_actionId,{channelId:this.props.channelId, rsd_service_id});
            });
            return;
        }
        var msg = {
            type: 'rsds',
            rsd_service_id,
            rsds: rsds
        };
        iframe.contentWindow.postMessage(msg, '*');
    }

    // send a single RSD to iframe 
    sendRSDToIframe=(rsd_service_id, rsd_id, action)=>{
        const iframe = this.iframe.current;
        if (!iframe) {
            console.log("sendRSDToIframe does not know iframe");
            return;
        }
        if (action && action.error) {
            console.log(`iframe requested rsd for rsd_service_id ${rsd_service_id} but we got an error`, action.error); // FIXME: remove debug spam
            iframe.contentWindow.postMessage({ type: 'rsd', rsd_service_id, rsd_id, invalid: true}, '*'); 
            return;
        }
        
        var rsd_services = this.getRSDServicesIfStored();
        if (!rsd_services) {
            if (this.state.get_rsd_services_actionId) {
                console.log(`cannot send rsds until we have rsd services`); // FIXME: remove debug spam
            }
            else {
                this.sendRSDServicesToIframe(true); // anticipate request-rsd-services (and we need the data to validate the rsd request)
            }
            console.log(`iframe requested rsd for rsd_service_id ${rsd_service_id} rsd_id ${rsd_id} but we are busy waiting for rsd_services`); // FIXME: remove debug spam
            iframe.contentWindow.postMessage({ type: 'rsd', rsd_service_id, rsd_id, busy: true}, '*'); // tell client we're busy so it knows to request again
            return;
        }
        var serviceData = _.find(rsd_services,{id:rsd_service_id});
        if (!serviceData) {
            console.log(`iframe requested rsd for invalid rsd_service_id ${rsd_service_id}`);
            iframe.contentWindow.postMessage({ type: 'rsd', rsd_service_id, rsd_id, invalid: true}, '*'); 
            return;
        }
        
        var rsd = this.getRSDIfStored(rsd_service_id, rsd_id);
        if (!rsd) {
            if (action) {
                console.log(`iframe requested rsd for rsd_service_id ${rsd_service_id} rsd_id ${rsd_id} but we didn't find it after the action`); // FIXME: remove debug spam
                iframe.contentWindow.postMessage({ type: 'rsd', rsd_service_id, rsd_id, invalid: true}, '*'); 
                return;
            }
            if (this.state.get_name_and_description_actionId) {
                console.log(`iframe requested rsd for rsd_service_id ${rsd_service_id} rsd_id ${rsd_id} but we are busy`); // FIXME: remove debug spam
                iframe.contentWindow.postMessage({ type: 'rsd', rsd_service_id, rsd_id, busy: true}, '*');
                return;
            }
            console.log(`forge client requesting rsd for ${rsd_service_id} ${rsd_id} from server`); // FIXME: remove debug spam
            let get_name_and_description_actionId = uuid.v4();
            let rsd_params = { rsd_service_id, rsd_id };
            this.setState({get_name_and_description_actionId, rsd_params},()=>{
                RSDActions.getNameAndDescription(get_name_and_description_actionId,rsd_params);
            });
            return;
        }
        else if (rsd.invalid) {
            console.log(`forge client requesting rsd for ${rsd_service_id} ${rsd_id} and we got an invalid rsd`); // FIXME: remove debug spam
            iframe.contentWindow.postMessage({ type: 'rsd', rsd_service_id, rsd_id, invalid: true}, '*'); 
            return;
        }
        var msg = {
            type: 'rsd',
            rsd_service_id,
            rsd_id,
            rsd: rsd
        };
        if (!rsd.name) {
            console.log("forge client got rsd without a name"); // FIXME: remove debug spam
        }
        console.log(`forge client requesting rsd for ${rsd_service_id} ${rsd_id} and we got it`); // FIXME: remove debug spam
        iframe.contentWindow.postMessage(msg, '*');
    }

    render() {
        let mainContent;
        let progressButton = null;
        let closeWarningBox = null;
        let disableSaveWS = false;
        let priorVersionAndUnsaved = false;
        let autosaveVersion = false;
        let editButtonText = 'Edit';
        let editingVersion = null;

        //console.debug(`props.activityVersion: ${this.props.activityVersion}, editingVersion: ${this.state.editingVersion}`);

        if (this.state.webSocketStoreState.error && !this.state.hadLockOnce) {
            mainContent = (
                <div className="mzlIFrame--other">
                    <WarningBox>
                        {this.state.webSocketStoreState.error.error}
                        <span style={{display:'none'}} aria-hidden={true}>
                            Step: {this.state.webSocketStoreState.error.step}
                        </span>
                    </WarningBox>
                </div>
            );
        }
        else if (this.state.webSocketStoreState.connection_perm_lost) {
            mainContent = (
                <div className="mzlIFrame--other">
                    <WarningBox>
                        Editing lock lost.
                    </WarningBox>
                </div>
            );
        }
        else {
            if (this.state.webSocketStoreState.force_unlock_data) {
                const forceUnlockData = this.state.webSocketStoreState.force_unlock_data || {}; // TODO we know this isn't falsy
                closeWarningBox = (
                    <ForceCloseEditModal
                        kickerName={forceUnlockData.kickerName}
                        unsavedChanges={this.state.unsavedChanges}
                        secondsTilClose={this.state.forceClosedSeconds}
                    />
                );
            }

            const _activity = this.props.activityStoreState.activity;
            const _template = this.props.templateStoreState.template;
            disableSaveWS = !this.state.currentlyHaveLock;
            priorVersionAndUnsaved = false;
            
            if (this.state.mode === 'EDIT') {
                if (this.state.autosaveModal) {
                    let confirmingDeleteAutosave = ( this.state.autosaveModal == 2);
                    let message = this.state.autosavePrefix;
                    if (confirmingDeleteAutosave) {
                        message += " Are you sure you wish to delete this autosave?";
                    }
                    else {
                        message += " What do you want to do?";
                    }
                    mainContent = (
                        <div className="mzlIFrame--other">
                            <ThreeModal modalTitle="Autosave Found" message={message} buttonData={this.getAutosaveButtonData(confirmingDeleteAutosave)} />
                        </div>
                    );
                }
                else if (!this.state.currentlyHaveLock && !this.state.hadLockOnce) {
                    // negotiating first lock
                    mainContent = (
                        <div className="mzlIFrame--other">
                            <LoadingMainContent />
                        </div>
                    );
                }
                else {
                    let editUrl = `${_template.editor_url}/edit/web/${_activity.activity_id}`;
                    editingVersion = this.getEditingVersion();
                    if (editingVersion) {
                        editUrl += `/${editingVersion}`;
                        if (editingVersion.indexOf('autosave') < 0) {
                            if (this.editingVersionIsOld()) {
                                priorVersionAndUnsaved = this.state.unsavedChanges;
                            }
                        }
                        else {
                            autosaveVersion = true;
                        }
                    }

                    mainContent = <IFrame ref={this.iframe} url={editUrl}/>;

                    progressButton = (
                        <div className={!this.state.unsavedChanges ? 'save-button disabled' : 'save-button'}>
                            <ProgressButton state={this.state.saveButtonState} onClick={this.onSave}>
                                Save
                            </ProgressButton>
                        </div>
                    );
                }
            }
            else if (this.state.mode === 'PREVIEW') {
                if (this.state.previewVersion) {
                    editButtonText += ` v${this.state.previewVersion}`;
                }

                // mainContent = <div>PREVIEW</div>;

                mainContent = (
                    <PreviewView
                        activityVersion={this.state.previewVersion}
                        previewFrom={this.state.previewFrom}
                        activityStoreState={this.props.activityStoreState}
                        templateStoreState={this.props.templateStoreState}
                        activityEditAccessInfo={this.props.activityEditAccessInfo}
                    />
                );
            }
            else {
                mainContent = (
                   <div className="mzlIFrame--other">
                        <WarningBox>
                            Invalid editor mode: "{this.state.mode}"
                        </WarningBox>
                    </div>
                );
            }
        }

        return (
            <div className="edit-activity">
                <Prompt message={this.allowLeave} />
                <TopNav logoLinkDisable>
                    {(this.state.webSocketStoreState.connection_lost) &&
                        <h2 style={{position: 'absolute', top: '15px', left: '-150px', color: 'red'}}>Connection lost</h2>
                    }
                    {(GlobalConfig.DevMode && this.state.signInStoreState.userInfo.admin) &&
                        <Button
                            variant="warning"
                            className="editorButton"
                            onClick={WebSocketActions.devTestWSDisconnect}
                            style={{position: 'absolute', left: '-200px'}}
                        >
                            DEV: Disonnect WS
                        </Button>
                    }
                    <HelpDropdown />
                    {(this.state.mode === 'EDIT') &&
                        <Button variant="light" className="editorButton margin-right-md" onClick={this.onClose}>
                            Close
                        </Button>
                    }
                    {(this.state.mode === 'EDIT'
                        && PermissionsUtil.canPreviewActivity(this.props.channelStoreState.channel.user_permissions, this.props.projectStoreState.project.user_permissions)
                    ) &&
                        <Tooltip
                            id="prev-ed-tt"
                            className="font-size-14px margin-right-md"
                            placement="bottom"
                            triggerElem={(
                                <div style={{display: 'inline-block', padding: '7px'}}>{/* padding necessary to get disabled tooltip to work*/}
                                    <Button
                                        variant="light"
                                        className="editorButton"
                                        onClick={this.gotoPreview}
                                        disabled={this.state.pendingSave || disableSaveWS || priorVersionAndUnsaved}
                                    >
                                        Preview
                                        {!!this.state.previewFrom &&
                                            <AccessibleIcon className="fa fa-play-circle-o margin-left-sm" label="from location" />
                                        }
                                    </Button>
                                </div>
                            )}
                        >
                        {(priorVersionAndUnsaved) ? 
                            "Because you loaded an older save version, You can't preview your changes without saving first. Please save to a new version, and then click preview again."
                            :
                            ( (editingVersion && !autosaveVersion && !this.state.launchedOldVersion) ?
                                "Preview version " + editingVersion + " of this activity as a student"
                                :
                                "Preview the current, edited version of this activity as a student"
                            )
                        }
                        </Tooltip>
                    }
                    {(this.state.mode === 'EDIT') && progressButton}
                    {(this.state.mode === 'PREVIEW') &&
                        <Button variant="light" className="editorButton" onClick={this.gotoEdit}>{editButtonText}</Button>
                    }
                </TopNav>

                {(disableSaveWS && this.state.hadLockOnce) &&
                    <div className="editor-blocker">
                        <WarningBox>Lost lock connection. <br/> Reconnecting...</WarningBox>
                        <LoadingMainContent/>
                    </div>
                }
                {mainContent}
                {closeWarningBox}
                {(this.state.modalState['save']) &&
                    <SingleInputModal
                        show
                        multiline
                        headerText="Save Activity"
                        inputLabel="Save Message"
                        ariaLabel="Save Message"
                        buttonText="confirm"
                        closeHandler={this.setSaveModalState.bind(this, false)}
                        submitHandler={this.save}
                    >
                        {(this.state.save_validation) &&
                            <div className="margin-top-lg">
                                <h2 className="margin-bottom-md">Validation Information</h2>
                                <ValidationReport className="mzl-cs-workarea" validationObj={this.state.save_validation} />
                            </div>
                        }
                    </SingleInputModal>
                }
                {(this.state.modalState['closeUnsaved']) &&
                    <ThreeModal
                        modalTitle="Unsaved Changes"
                        message="You have unsaved changes. Are you sure you wish to leave this page?"
                        buttonData={[
                            {
                                text: 'Save & Close',
                                handler: this.saveAndClose
                            },
                            {
                                text: 'Discard & Close',
                                handler: this.deleteAutoSaveAndClose
                            },
                            {
                                text: 'Cancel',
                                handler: this.setCloseUnsavedModalState.bind(this, false)
                            }
                        ]}
                    />
                }
            </div>
        );
    }
}

EditActivityView.propTypes = propTypes;
EditActivityView.defaultProps = defaultProps;

const WrappedComponent = withRouter(WithSiteMaintenanceMode(WithDocumentVisible(WithActivityData(WithTemplateData(WithChannelData(WithProjectData(WithActivityEditAccessData(EditActivityView))))))));

// WithActivityData is expected the activityId prop. "Rename" props.params.activityID to props.activityId here. do the same with projectId, channelId, activityVersion
// ensure that MaintenanceWarning component is render if maintenanceMode is active
function WrappedComponentWithUpdatedPropNames(props) {
    return (
        <WrappedComponent
            {...props}
            activityId={props.match.params.activityId}
            projectId={props.match.params.projectID}
            channelId={props.match.params.channel}
            activityVersion={props.match.params.activityVersion}
            renderWarningDuringMaintenence
        />
    );
}

WrappedComponentWithUpdatedPropNames.propTypes = {
    match: PropTypes.shape({
        params: PropTypes.shape({
            channel: PropTypes.string.isRequired,
            projectID: PropTypes.string.isRequired,
            activityId: PropTypes.string.isRequired,
            activityVersion: PropTypes.string,
        }).isRequired,
    }).isRequired,
};

export default WrappedComponentWithUpdatedPropNames;